import React from 'react';
import './App.css';
import { Button } from 'antd';
import Layout from './Containers/Layout/Layout';
import { BrowserRouter as Router } from "react-router-dom";

function App() {
  return (
    <div className="app">
      <Router>
        <Layout/>
      </Router>
    </div>
  );
}

export default App;
